import React from 'react';
import { Button, Modal } from 'angieslist-react-components';
import { Track } from 'angieslist-app-platform';
import './DeleteLicenseModal.scss';

type Props = {
  onHide: () => void,
  showModal: boolean,
  onDelete: () => void,
  licenseNumber: number,
}

const DeleteLicenseModal = ({
  onHide,
  showModal,
  onDelete,
  licenseNumber,
}: Props) =>
  (
    <Modal
      show={showModal}
      id="delete-license-modal"
    >
      <Modal.Header closeButton onHide={onHide}>
        <Modal.Title>Are you sure you want to remove the selected license?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Consumers find licensing very important when they choose a pro to work with.
        Removing licenses from your business will remove them from your profile. You can add
        licenses in the future by clicking &lsquo;Add New License&rsquo;.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Track>
          <Button bsStyle="default-office" id="Delete-License-Modal--Cancel-Button" onClick={onHide}>Cancel</Button>
        </Track>
        <Track>
          <Button
            id="Delete-License-Modal--Delete-Button"
            bsStyle="danger"
            flat
            onClick={onDelete}
            data-track-license-number={licenseNumber}
          >Remove Selected License
          </Button>
        </Track>
      </Modal.Footer>
    </Modal>
  );


export default DeleteLicenseModal;



// WEBPACK FOOTER //
// ./src/modules/profile/browser/components/DeleteLicenseModal.js